import { lightComponentColors } from "./componentColors";

export const lemmonLight = {
  lemmonLight: {
    "color-scheme": "light",
    primary: "#047aff",

    "primary-content": "#fff",

    secondary: "#101923",

    "secondary-content": "#fff",

    accent: "#000",

    "accent-content": "#fff",

    neutral: "#5c6e82",

    "neutral-content": "#fff",

    "base-100": "#ffffff",

    "base-200": "#f4f6f9",
    "base-300": "#e9ecf1",
    "base-content": "#374151",
    "--form-control-background": "#e9ecf1",
    "--lemmon-switcher-background": "rgba(55, 65, 81, 0.06)",
    "--lemmon-switcher-border": "rgba(55, 65, 81, 0.12)",
    "--lemmon-switcher-indicator-background": "rgba(255, 255, 255, 0.82)",
    "--lemmon-switcher-indicator-overlay-background": "rgba(4, 122, 255, 0.08)",
    "--lemmon-switcher-indicator-shadow": "rgba(15, 23, 42, 0.16) 0px 1px 3px",

    info: "#0099e3",

    "info-content": "#fff",

    success: "#11B981",

    "success-content": "#fff",

    warning: "#f4bf50",

    "warning-content": "#000",

    error: "#CA2625",

    "error-content": "#fff",

    "--pos-card-bg": "#eef1f6",
    "--pos-card-selected-bg": "#f4f6f9",
    "--pos-bar-color": "#101923",
    "--body-bg-color": "#f4f6f9",
    "--pos-panel-bg": "#e9ecf1",
    "--pos-border-color": "#d1d5db",
    "--pos-shadow-color": "#0000001a",
    "--pos-shadow-highlight": "rgba(255,255,255,0.8)",
    ...lightComponentColors,
  },
};
